import { z } from 'zod/v4';

/** `?date=YYYY-MM-DD` — the day the usage counts are read for (defaults today). */
export const ApiKeyUsageQuery = z.object({
  date: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'date must be YYYY-MM-DD')
    .optional(),
});
export type ApiKeyUsageQueryType = z.infer<typeof ApiKeyUsageQuery>;

export const ApiKeyUsageSchema = z.object({
  apiKeyId: z.string(),
  serviceAccountId: z.string(),
  serviceAccountName: z.string().nullable(),
  label: z.string().nullable(),
  keyPrefix: z.string().nullable(),
  removedAt: z.union([z.string(), z.date()]).nullable(),
  limitPerMinute: z.number(),
  createdAt: z.union([z.string(), z.date()]),
  lastUsedAt: z.union([z.string(), z.date()]).nullable(),
  usageDate: z.union([z.string(), z.date()]),
  requestCount: z.coerce.number(),
});

export type ApiKeyUsageView = z.infer<typeof ApiKeyUsageSchema>;
